module.exports = __webpack_public_path__ + "static/media/bk-menu-inactive.651330ba.png";